const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-slate-50 pt-32 pb-20">
      <div className="mx-auto max-w-4xl px-5 lg:px-8">
        <div className="mb-8">
          <span className="inline-block bg-[#94cf1c] px-3 py-1 text-xs font-bold uppercase tracking-wider text-white">
            Ley Federal de Protección de Datos
          </span>
          <h1 className="mt-4 text-4xl font-bold text-[#0A2540]">
            Aviso de Privacidad
          </h1>
          <p className="mt-2 text-sm text-slate-500">
            Última actualización: {new Date().toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
          <p className="text-sm text-slate-600 mt-1">
            Con fundamento en los artículos 15 y 16 de la LFPDPPP
          </p>
        </div>

        <div className="prose prose-slate max-w-none">
          <div className="bg-[#0A2540]/5 border-l-4 border-[#94cf1c] p-6 rounded-r mb-8">
            <p className="text-sm text-slate-700">
              <strong>CLEAN WORK</strong>, con domicilio en Norte 3 núm. 24 - A Nuevo Parque Industrial,
              San Juan del Río, Qro. CP 76806, es responsable del tratamiento
              de sus datos personales, en cumplimiento con la{' '}
              <strong>Ley Federal de Protección de Datos Personales en Posesión de los Particulares</strong>{' '}
              y su Reglamento.
            </p>
          </div>

          <h2 className="text-2xl font-bold text-[#0A2540] mt-8 mb-4">
            1. Datos Personales que Recopilamos
          </h2>
          <p className="text-slate-600">
            Con fundamento en la Ley Federal de Protección de Datos Personales en Posesión de los Particulares,
            recopilamos los siguientes datos personales:
          </p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2">
            <li>Nombre completo</li>
            <li>Empresa o institución</li>
            <li>Teléfono de contacto</li>
            <li>Correo electrónico</li>
            <li>Tipo de instalación</li>
            <li>Tamaño del espacio</li>
            <li>Frecuencia de servicio requerida</li>
            <li>Mensaje o comentarios adicionales</li>
          </ul>
          <p className="text-sm text-slate-500 mt-2">
            <em>Nota: No recopilamos datos personales sensibles.</em>
          </p>

          <h2 className="text-2xl font-bold text-[#0A2540] mt-8 mb-4">
            2. Finalidades del Tratamiento
          </h2>
          <p className="text-slate-600">
            De conformidad con los principios de finalidad y proporcionalidad establecidos en la Ley,
            utilizamos sus datos para:
          </p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2">
            <li>Procesar solicitudes de cotización</li>
            <li>Contactarle para brindar información sobre nuestros servicios</li>
            <li>Enviar propuestas personalizadas de limpieza</li>
            <li>Dar seguimiento a sus requerimientos</li>
            <li>Mejorar nuestros servicios y atención al cliente</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#0A2540] mt-8 mb-4">
            3. Consentimiento
          </h2>
          <p className="text-slate-600">
            Al proporcionar sus datos personales a través de nuestro formulario,
            usted otorga su <strong>consentimiento expreso</strong> para el tratamiento
            de los mismos.
          </p>
          <div className="bg-slate-100 p-4 rounded border border-slate-200 mt-2">
            <p className="text-sm text-slate-600">
              <strong>⚡ Importante:</strong> El consentimiento podrá ser revocado
              en cualquier momento, sin efectos retroactivos.
            </p>
          </div>

          <h2 className="text-2xl font-bold text-[#0A2540] mt-8 mb-4">
            4. Derechos ARCO
          </h2>
          <p className="text-slate-600">
            Usted tiene derecho a ejercer los <strong>Derechos ARCO</strong>
            (Acceso, Rectificación, Cancelación y Oposición) al tratamiento de sus
            datos personales.
          </p>
          <p className="text-slate-600 mt-2">
            Para ejercer estos derechos, puede contactarnos a través de:
          </p>
          <div className="bg-slate-100 p-4 rounded border border-slate-200 mt-2">
            <p className="text-sm text-slate-700">
              <strong>Correo electrónico:</strong>{' '}
              <a href="mailto:aydnieto@gmail.com" className="text-[#00a7e2] hover:underline">
                aydnieto@gmail.com
              </a>
              <br />
              <strong>Domicilio:</strong> Norte 3 núm. 24 - A Nuevo Parque Industrial,
              San Juan del Río, Qro. CP 76806
            </p>
          </div>

          <h2 className="text-2xl font-bold text-[#0A2540] mt-8 mb-4">
            5. Transferencia de Datos
          </h2>
          <p className="text-slate-600">
            Sus datos personales no serán transferidos a terceros, salvo
            obligación legal o consentimiento expreso.
          </p>

          <h2 className="text-2xl font-bold text-[#0A2540] mt-8 mb-4">
            6. Seguridad de los Datos
          </h2>
          <p className="text-slate-600">
            Implementamos medidas de seguridad administrativas, técnicas y físicas
            para proteger sus datos personales contra daño, pérdida, alteración,
            destrucción o uso indebido.
          </p>

          <h2 className="text-2xl font-bold text-[#0A2540] mt-8 mb-4">
            7. Modificaciones al Aviso de Privacidad
          </h2>
          <p className="text-slate-600">
            Cualquier modificación a este aviso de privacidad será comunicada a
            través de nuestro sitio web.
          </p>

          <div className="mt-8 pt-8 border-t-2 border-[#94cf1c]/30">
            <p className="text-xs text-slate-500">
              Este Aviso de Privacidad se rige por la Ley Federal de Protección de Datos
              Personales en Posesión de los Particulares.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;